import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

import {
    firstPersonIrregularData,
    gerundioExamples,
    gerundioExplanation,
    irregularGerundiosData,
    irregularVerbs,
    presentTenseExplanation,
    regularVerbs,
    stemChangingVerbsData
} from "src/data/individual-topics/PresentTense";

const PresenteTenseContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>
            <div className="section">
                <ExplanationCard cardData={presentTenseExplanation} />
            </div>

            <div className="section">
                <ConjugationTable tableData={{ title: "Regular Verbs", verbs: regularVerbs }} />
            </div>

            <div className="section">
                <ExplanationCard cardData={stemChangingVerbsData} />
            </div>

            <div className="section">
                <ExplanationCard cardData={firstPersonIrregularData} />
            </div>

            <div className="section">
                <ConjugationTable tableData={{ title: "Irregular Verbs", verbs: irregularVerbs }} />
            </div>

            <div className="section">
                <ExplanationCard cardData={gerundioExplanation} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {gerundioExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ExplanationCard cardData={irregularGerundiosData} />
            </div>
        </div>
    );
};

const PresenteTenseScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Present Tense"
            Page={<PresenteTenseContent />}
        />
    );
};

export default PresenteTenseScreen;
